module.exports = __webpack_public_path__ + "static/media/skull_right.8b0c0983.png";